import React, { useState } from "react";
import img47 from '../images/image47.png';
import img48 from '../images/image48.png';
import img49 from '../images/image.jpeg';
import Footer from "../Footer";

const SIG = () => {
  const [expanded, setExpanded] = useState(null);

  const handleToggle = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const cardsData = [
    {
      title: 'Social Stock Exchange',
      img: img47,
      description: 'The Social Stock Exchange is a progressive initiative aimed at enabling non-profit organizations to raise funds in a structured manner. This involves assessing projects through trained social impact assessors to ensure their viability.'
    },
    {
      title: 'Social Entrepreneurship Club',
      img: img48,
      description: 'The Social Entrepreneurship Club brings together TISSAA Alums who have ventured into social enterprises to create a positive impact. This SIG serves as a platform for Alums to discuss the challenges and opportunities in social entrepreneurship.'
    },
    {
      title: 'Job Placement',
      img: img49,
      description: 'The Job Placement SIG addresses the need for high-quality, trusted human resources in organizations while helping Alums seeking job opportunities. Senior Alums are often in search of skilled professionals for their organizations.'
    },
  ];

  return (
    <div>
    <div style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center", fontSize: "1.5rem", marginBottom: "40px", fontFamily: "Inter" }}>
        Special Interest Group (SIG)
      </h1>
      <div style={styles.cardsContainer}>
        {cardsData.map((card, index) => (
          <div key={index} style={styles.card}>
            {card.img && <img src={card.img} alt={card.title} style={styles.cardImage} />}
            <h2 style={styles.cardTitle}>{card.title}</h2>
            <p style={styles.cardDescription}>
              {expanded === index ? card.description : `${card.description.substring(0, 140)}...`}
              <span
                onClick={() => handleToggle(index)}
                style={styles.readMore}
              >
                {expanded === index ? "Show Less" : "Read More"}
              </span>
            </p>
          </div>
        ))}
      </div>
      </div>
      <Footer/>
    </div>
  );
};

const styles = {
  cardsContainer: {
    display: 'flex',
    flexWrap: "wrap",
    gap: '250px',
    alignItems: 'center',
    justifyContent: "center",
  },
  card: {
    width: '300px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    padding: '15px',
    transition: 'transform 0.3s ease',
    overflow: 'hidden',
    textAlign: 'center',
  },
  cardImage: {
    width: '100%',
    height: '300px',
    objectFit: 'cover',
    borderRadius: '8px',
    marginBottom: '15px',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontFamily: 'Inter',
    marginBottom: '10px',
  },
  cardDescription: {
    fontSize: '1.2rem',
    fontFamily: 'Tahoma',
    color: '#555',
    lineHeight: '1.6',
    marginBottom: '15px',
  },
  readMore: {
    color: '#007BFF',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};

export default SIG;





// import React from "react";
// import img47 from '../images/image47.png';
// import img48 from '../images/image48.png';

// const SIG = () => {
//   return (
//     <div style={{ padding: "20px" }}>
//       <h1 style={{ textAlign: "center", fontSize: "2.5rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Special Interest Group (SIG)
//       </h1>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         TISSAA encourages Alums to form Special Interest Groups (SIGs) based on their diverse backgrounds and professional
//         interests. These groups focus on a range of topics, from business to social issues, education to healthcare, and
//         career development to emerging trends. By promoting freedom of speech and facilitating in-depth discussions, TISSAA
//         helps Alums come together to address specific causes. Alums can submit proposals to form SIGs, and once approved,
//         TISSAA supports these groups by showcasing their activities and outcomes on networks and social media, fostering
//         continuous engagement and impactful policy change.
//       </p>
//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Social Stock Exchange
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The Social Stock Exchange is a progressive initiative aimed at enabling non-profit organizations to raise funds in
//         a structured manner, similar to the process for private companies. This involves assessing projects through trained
//         social impact assessors to ensure their viability. TISSAA Alums, who are certified social impact assessors, have
//         formed a SIG focused on Social Impact Assessment. This group discusses the regulatory framework, shares expertise,
//         and collaborates to help social organizations get listed on the Social Stock Exchange, thereby contributing to the
//         growth of the social sector.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img47} alt="Alumni Meet 1" style={styles.image} />
//       </div>

//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Social Entrepreneurship Club
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The Social Entrepreneurship Club brings together TISSAA Alums who have ventured into social enterprises to create
//         a positive impact. This SIG serves as a platform for Alums to discuss the challenges and opportunities in social
//         entrepreneurship, explore potential collaborations, and support each other. By organizing online sessions and
//         ongoing discussions, the club fosters a strong community where social entrepreneurs can grow their businesses,
//         share knowledge, and work collectively to address social issues.
//       </p>
//       <div style={styles.imageContainer}>
//         <img src={img48} alt="Alumni Meet 1" style={styles.image} />
//       </div>

//       <h2 style={{ textAlign: "left", fontSize: "2rem", marginBottom: "20px", fontFamily: "Inter" }}>
//         Job Placement
//       </h2>
//       <p style={{ fontSize: "1.2rem", marginBottom: "30px", fontFamily: "Tahoma", marginLeft: "15px" }}>
//         The Job Placement SIG addresses the need for high-quality, trusted human resources in organizations while helping
//         Alums seeking job opportunities. Senior Alums are often in search of skilled professionals for their organizations,
//         but struggle with the time and budget constraints in finding suitable candidates. Meanwhile, other Alums are actively
//         seeking job opportunities in trusted organizations. This group functions as an informal yet effective platform where
//         Alums can share job openings and connect with potential candidates, fostering a mutually beneficial network for both
//         job seekers and employers.
//       </p>
//     </div>
//   );
// };
// const styles = {
//   imageContainer: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
//     gap: '15px',
//     marginBottom: '40px',
//     justifyItems: 'center',
//   },
//   image: {
//     width: '100%',
//     height: 'auto',
//     borderRadius: '8px',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//     transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//   },
//   imageHover: {
//     transform: 'scale(1.05)',
//     boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)',
//   }
// };
// export default SIG;
